import {
  START_EXAM,
  START_CHALLENGE,
  SAVE_EXAM,
  LIST_EXAM,
  REMOVE_EXAM,
  VIEW_EXAM,
  CLEAR_ERRORS,
  EXAM_LOADING,
  RESET_EXAM
} from '../actions/types';

const initialState = {
  exam: {},
  exams: [],
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case EXAM_LOADING:
      return {
        ...state,
        loading: true
      };
    case START_EXAM:
    case VIEW_EXAM:
      return {
        ...state,
        exam: action.payload,
        loading: false
      };
    case LIST_EXAM:
      return {
        ...state,
        exams: action.payload,
        loading: false
      };
    case SAVE_EXAM:
      return {
        ...state,
        // exam: action.payload,
        loading: false
      };
    case RESET_EXAM:
      return {
        ...state,
        // exam: action.payload,
        exam: {}
      };
    default:
      return state;
  }
}
